import React from 'react';
import styled, { css } from 'styled-components';
import { darken } from 'polished';
import { Icon } from '../Icon';
import { theme } from '../theme';
import { focusOutlineStyle } from '../utils/focusOutline';
const iconSizes = {
    48: {
        smallSize: 28,
        padding: 10,
    },
    36: {
        smallSize: 20,
        padding: 8,
    },
    24: {
        smallSize: 12,
        padding: 6,
    },
    16: {
        smallSize: 10,
        padding: 3,
    },
};
export const IconStrict = ({ id, className = '', size = 16, render, iconColor, backgroundColor, rotate, handleClick, title, ...otherProps }) => {
    const isButton = !!handleClick;
    const defaultLabel = isButton ? (title ? title : 'icon-button') : undefined;
    return (React.createElement(IconContainer, { id: id, as: isButton ? 'button' : 'div', className: className, "$size": size, "$backgroundColor": backgroundColor, onClick: handleClick, title: defaultLabel, ...otherProps },
        React.createElement(Icon, { render: render, size: backgroundColor ? iconSizes[size].smallSize : size, color: iconColor, rotate: rotate })));
};
const IconContainer = styled.div(({ $size, $backgroundColor, onClick }) => css `
    position: relative;
    padding: ${$backgroundColor ? `${iconSizes[$size].padding}px` : 0};
    width: 100%;
    max-width: ${$size}px;
    height: ${$size}px;
    border-radius: 100%;
    background-color: ${$backgroundColor
    ? theme.colors[$backgroundColor]
    : 'none'};
    cursor: ${onClick ? 'pointer' : 'default'};

    ${onClick &&
    `
    &:hover {
      background-color: ${$backgroundColor ? darken(0.1, theme.colors[$backgroundColor]) : 'none'};
    }
      
    `}

    ${focusOutlineStyle}
  `);
//# sourceMappingURL=IconStrict.js.map